import React, { useState, useEffect } from 'react'

const Alien = ({ followMouse }) => {
  const [pupilTop, setPupilTop] = useState('50%')
  const [pupilLeft, setPupilLeft] = useState('50%')
  const [pupilTransform, setPupilTransform] = useState('translate(-50%, -50%)')

  const handleMouseMove = e => {
    let x = (e?.clientX * 100) / window.innerWidth + '%'
    let y = (e?.clientY * 100) / window.innerHeight + '%'
    setPupilLeft(x)
    setPupilTop(y)
    setPupilTransform(`translate(-${x},-${y})`)
  }

  useEffect(() => {
    handleMouseMove(followMouse && followMouse)
  }, [followMouse])

  return (
    <div className='alien'>
      <div className='monster'>
        <div className='body'>
          <div className='ear'></div>
          <div className='ear'></div>
          <div className='vampi-mouth'>
            <div className='vampi-tooth'></div>
          </div>
        </div>
        <div className='eye-lid'>
          <div
            className='eyes'
            style={{
              top: pupilTop,
              left: pupilLeft,
              transform: pupilTransform,
            }}
          >
            <div className='eye'></div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Alien
